import { useToast } from "@chakra-ui/react";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { ButtonVariant } from "../../../components/atoms/ButtonVariant";
import { errorToastOptions } from "../../../components/molecules/errorToastOptions";
import { captureRequestError } from "../../../helper/captureRequestError";
import { getFullPageUrl } from "../../../helper/getFullPageUrl";
import { Route, useNavigator } from "../../../routers/navigator";

export const PurchasePlanButton = ({ accountId }: { accountId: string }) => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const toast = useToast(errorToastOptions);

  const navigate = useNavigator();

  const handleClick = async () => {
    setIsLoading(true);
    try {
      navigate({
        route: Route.Plans,
        accountId,
        state: {
          referringUrl: getFullPageUrl(location),
        },
      });
    } catch (error) {
      captureRequestError(error);
      toast({
        title: "Failed to open checkout",
        description: "An unexpected error occurred. Please try again later.",
      });
      setIsLoading(false);
    }
  };

  return (
    <ButtonVariant
      isLoading={isLoading}
      content="Purchase Plan"
      color="red"
      size="sm"
      onClick={handleClick}
    ></ButtonVariant>
  );
};
